import api from './api';

// Mapper les champs API vers le format attendu par les composants
const mapInstructor = (inst) => ({
  id: inst.id,
  name: inst.instructor_name || inst.name || 'Instructeur',
  role: inst.title || inst.specialty || 'Formateur',
  image: inst.instructor_avatar || inst.avatar_url || inst.profile_photo || null,
  rating: parseFloat(inst.rating) || 0,
  students: inst.total_students || 0,
  courses: inst.courses_count || inst.total_courses || 0,
  bio: inst.instructor_bio || inst.bio || '',
  expertise_areas: inst.expertise_areas || [],
  years_experience: inst.years_experience || 0,
  institution_id: inst.institution_id || null,
});

const extractList = (data) =>
  Array.isArray(data) ? data : (data?.data ?? []);

const instructorService = {
  // Récupérer tous les instructeurs
  getAllInstructors: async (filters = {}) => {
    try {
      const response = await api.get('/instructors');
      let results = extractList(response.data).map(mapInstructor);

      // Filtrage côté client
      if (filters.search) {
        const term = filters.search.toLowerCase();
        results = results.filter(inst =>
          inst.name.toLowerCase().includes(term) ||
          inst.role.toLowerCase().includes(term)
        );
      }

      if (filters.category && filters.category !== 'All Categories') {
        results = results.filter(inst => inst.role === filters.category);
      }

      // Tri
      const sortKey = typeof filters.sort === 'string'
        ? filters.sort.replace('Sort by: ', '')
        : '';
      if (sortKey === 'Rating') results.sort((a, b) => b.rating - a.rating);
      else if (sortKey === 'Students') results.sort((a, b) => b.students - a.students);
      else if (sortKey === 'Courses') results.sort((a, b) => b.courses - a.courses);

      // Pagination côté client
      const page = filters.page || 1;
      const limit = filters.limit || 8;
      const start = (page - 1) * limit;
      const paginated = results.slice(start, start + limit);

      return {
        instructors: paginated,
        totalCount: results.length,
        currentPage: page,
        totalPages: Math.ceil(results.length / limit),
      };
    } catch (error) {
      console.error('Error fetching instructors:', error);
      throw error;
    }
  },

  // Récupérer un instructeur par ID
  getInstructorById: async (id) => {
    try {
      const response = await api.get(`/instructors/${id}`);
      const data = response.data?.id ? response.data : (response.data?.data ?? response.data);
      return mapInstructor(data);
    } catch (error) {
      console.error(`Error fetching instructor ${id}:`, error);
      throw error;
    }
  },

  // Récupérer les instructeurs les mieux notés (pour la home)
  getTopRatedInstructors: async (limit = 4) => {
    try {
      const response = await api.get('/instructors');
      const list = extractList(response.data).map(mapInstructor);
      return list.sort((a, b) => b.rating - a.rating).slice(0, limit);
    } catch (error) {
      console.error('Error fetching top instructors:', error);
      throw error;
    }
  },

  // Récupérer les spécialités/catégories distinctes des instructeurs
  getCategories: async () => {
    try {
      const response = await api.get('/instructors');
      const list = extractList(response.data).map(mapInstructor);
      return [...new Set(list.map(inst => inst.role).filter(Boolean))];
    } catch (error) {
      console.error('Error fetching instructor categories:', error);
      throw error;
    }
  },
};

export default instructorService;
